import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'reactstrap';
import {
  PRESENTER_SETTINGS,
  PresenterSettings as PresenterSettingsComponent,
} from '@shoflo/polymer';
import { updatePresenterSettings } from 'actions/presenter';
import { useModal } from 'hooks';
import { CAMERA_PRESENTER } from '@studio/constants';

function PresenterSettings() {
  const dispatch = useDispatch();
  const meetingSession = useSelector((state) => state.meeting.meetingSession);
  const attendeeTiles = useSelector((state) => state.meeting.attendeeTiles);
  const presenterSettingsSource = useSelector(
    (state) => state.presenterSettingsSource
  );
  const { isOpen, clear } = useModal(PRESENTER_SETTINGS);

  function handleFormSave(payload) {
    dispatch(updatePresenterSettings(presenterSettingsSource, payload));
    clear();
  }

  const maxWidthMap = {
    [CAMERA_PRESENTER]: '436px',
    default: '572px',
  };

  const style = {
    maxWidth: maxWidthMap[presenterSettingsSource.type] || maxWidthMap.default,
  };

  return (
    <Modal isOpen={isOpen} toggle={clear} autoFocus style={style}>
      <PresenterSettingsComponent
        source={presenterSettingsSource}
        meetingSession={meetingSession}
        attendeeTiles={attendeeTiles}
        onSubmit={handleFormSave}
        onCancel={clear}
      />
    </Modal>
  );
}

export default PresenterSettings;
